import { selectChangeMessageForHtmlString } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForHtmlString';
import { selectQuoteNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, RequiredType } from '@nodeTypeConfig/configTypes';
import { attachedContentComponent } from '@nodeTypeConfig/helpers/editComponents/attachedContent';

const QUOTE: BuildingBlockNodeConfig = {
  nodeSelector: selectQuoteNode,
  information: {
    single: 'Citaat',
    plural: 'Citaten',
    ribonIcon: require('../../../../img/buildingBlocks/quote_xl.svg'),
  },
  buildingBlocks: [],
  createDefaults: {
    attachments: [
      {
        type: 'CONTENT',
        name: 'content.html',
        contentType: 'text/html',
      },
    ],
  },
  edit: [
    {
      ...attachedContentComponent,
      label: 'Citaat',
      definiteArticle: true,
      required: RequiredType.ERROR,
    },
    {
      component: 'authors',
      property: 'creators[0]',
      reactComponent: 'AsideFreeTextAuthor',
      label: 'Auteurs',
      asideChangeMessageSelector: selectChangeMessageForHtmlString,
      // for QUOTE this is free text ("alia iacta est" - Julius Caesar) and not an href to /persons
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    focusOnField: 'html',
  },
};

export default QUOTE;
